import { render } from "./TipsBanner.vue?vue&type=template&id=f08e98ba&scoped=true"
const script = {}

import "./TipsBanner.vue?vue&type=style&index=0&id=f08e98ba&lang=scss&scoped=true"

import exportComponent from "/var/vsts_agent/_work/1505/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f08e98ba"]])

export default __exports__